import { connect } from 'react-redux';
import InvoiceSubmission from 'components/Unauth/InvoiceSubmission';
import { verifyRecaptchaToken, submitExternalApplication, fetchClientFormConfig } from 'actions/public';
import { getFormSyncErrors } from 'redux-form';

function mapStateToProps(state) {
    return {
        syncErrors: getFormSyncErrors('applicationForm')(state),
        clientFormConfig: state.publicConfig.clientFormConfig,
        formValues: state.form?.applicationForm?.values || {}
    };
}

function mergeProps(stateProps, dispatchProps, ownProps) {
    return {
        ...stateProps,
        ...ownProps,
        ...dispatchProps,
    }
}

export default connect(
    mapStateToProps,
    { verifyRecaptchaToken, submitExternalApplication, fetchClientFormConfig },
    mergeProps
)(InvoiceSubmission);
